export const depositFiatImages = [
    'stepDashboard.webp',
    'stepDeposit.webp',
    'stepFiat.webp',
    'stepGel.webp',
    'stepBankwire.webp',
    'stepContinue.webp',
    'stepDetails.webp',
];
export const depositFiatImagesEng = [
    'stepDashboardEng.webp',
    'stepDepositEng.webp',
    'stepFiatDepositEng.webp',
    'stepGelDepositEng.webp',
    'stepDepMethBankwireEng.webp',
    'stepFiatDepositBwContinueEng.webp',
    'stepFiatDepositIban.webp',
];
export const depositFiatCardImages = [
    'stepDashboard.webp',
    'stepDeposit.webp',
    'stepFiat.webp',
    'stepGel.webp',
    'stepCreditCard.webp',
    'stepCardContinue.webp',
    'stepDepositAmount.webp',
    'stepAddCard.webp',
    'stepCardDetails.webp',
    'stepChooseCard.webp',
    'stepContinueFiatWithdraw.webp',
];
export const depositFiatCardImagesEng = [
    'stepDashboardEng.webp',
    'stepDepositEng.webp',
    'stepFiatDepositEng.webp',
    'stepGelDepositEng.webp',
    'stepFiatDepositMethCardEng.webp',
    'stepFiatDepositCardContinueEng.webp',
    'stepFiatDepositChooseAmountEng.webp',
    'stepFiatDepositAddCardEng.webp',
    'stepDepositFiatCardDetailsEng.webp',
    'stepDepositFiatChooseCardEng.webp',
    'stepDepositFiatChooseCardContinueEng.webp',
];
export const withdrawFiatBankwireImages = [
    'stepDashboard.webp',
    'stepWithdraw.webp',
    'stepFiatWithdraw.webp',
    'stepGelWithdraw.webp',
    'stepChooseMethodBankwireWithdraw.webp',
    'stepContinueFiatWithdrawBankwire.webp',
    'stepAmount.webp',
    'stepAccNumber.webp',
    'stepAccountNumberContinue.webp',
    'stepContinueSecond.webp',
    'stepRecievedSms.webp',
];
export const withdrawFiatBankwireImagesEng = [
    'stepDashboardEng.webp',
    'stepWithdrawEng.webp',
    'stepWithdrawFiatEng.webp',
    'stepWithdrawFiatGelEng.webp',
    'stepWithdrawFiatMethBwEng.webp',
    'stepWithdrawFiatBwContinueFirstEng.webp',
    'stepChooseAmountWithdrawFiatBwEng.webp',
    'stepEnterAccNumberBwWithdrawEng.webp',
    'stepWithdrawFiatBwContinueEng.webp',
    'stepConfirmWithdrawBwContinueEng.webp',
    'stepConfirmWithdrawBwSmsEng.webp',
];
export const withdrawFiatCardImages = [
    'stepDashboard.webp',
    'stepWithdraw.webp',
    'stepFiatWithdraw.webp',
    'stepGelWithdraw.webp',
    'stepChooseCardMethodWithdraw.webp',
    'stepChooseCardMethodWithdrawContinue.webp',
    'stepChooseFiatWithdrawAmount.webp',
    'stepChooseCardWithdrawCard.webp',
    'stepCardChooseWithdrawCardContinue.webp',
    'stepContinueFIatWithdrawSecond.webp',
    'stepRecievedSms.webp',
];
export const withdrawFiatCardImagesEng = [
    'stepDashboardEng.webp',
    'stepWithdrawEng.webp',
    'stepWithdrawFiatEng.webp',
    'stepWithdrawFiatGelEng.webp',
    'stepWithdrawFiatChooseMethCardEng.webp',
    'stepWithdrawFiatChooseMethCardContinueEng.webp',
    'stepWithdrawFiatCardChooseAmountEng.webp',
    'stepWithdrawFiatCardChooseCardEng.webp',
    'stepWithdrawFiatCardChooseCardContinueEng.webp',
    'stepWithdrawFiatCardConfirmWithdrawContinueEng.webp',
    'stepConfirmWithdrawaCardSmsEng.webp',
];
export const depositCryptoBankwireImages = [
    'stepDashboard.webp',
    'stepDeposit.webp',
    'stepCrypto.webp',
    'stepChooseCrypto.webp',
    'stepChooseNetworkDeposit.webp',
    'stepScanQr.webp',
];
export const depositCryptoBankwireImagesEng = [
    'stepDashboardEng.webp',
    'stepDepositEng.webp',
    'stepCryptoDepositEng.webp',
    'stepCryptoDepositChooseCryptoEng.webp',
    'stepCryptoDepositChooseNetworkEng.webp',
    'stepCryptoDepositScanQr.webp',
];
export const withdrawCryptoBankWireImages = [
    'stepDashboard.webp',
    'stepWithdraw.webp',
    'stepChooseCryptoWithdraw.webp',
    'stepChoosePrefCryptoWithdraw.webp',
    'stepChooseCryptoAmount.webp',
    'stepChooseCryptoAddress.webp',
    'stepChooseNetworkWithdraw.webp',
    'stepCryptoWIthdrawContinue.webp',
    'stepCryptoWithdrawDetails.webp',
];
export const withdrawCryptoBankWireImagesEng = [
    'stepDashboardEng.webp',
    'stepWithdrawEng.webp',
    'stepCryptoWithdrawEng.webp',
    'stepCryptoWithdrawChooseCryptoEng.webp',
    'stepCryptoWithdrawChooseCryptoAmountEng.webp',
    'stepWithdrawCryptoChooseWalletAddressEng.webp',
    'stepWithdrawCryptoChooseNetworkEng.webp',
    'stepWithdrawCryptoContinueEng.webp',
    'stepWithdrawCryptoContinueSecondEng.webp',
];
export const registrationImages = [
    'stepOneReg.webp',
    'stepTwoReg.webp',
    'stepThreeReg.webp',
    'stepFourReg.webp',
    'stepFiveReg.webp',
    'stepSixReg.webp',
    'stepSevenReg.webp',
    'stepEightReg.webp',
    'stepNineReg.webp',
    'stepTenReg.webp',
    'stepElevenReg.webp',
    'stepTwelveReg.webp',
    'StepThirteenReg.webp',
    'stepFourteenReg.webp',
    'stepFifteenReg.webp',
    'stepSixteenReg.webp',
    'stepSeventeenReg.webp',
    'stepEighteenReg.webp',
    'stepNineteenReg.webp',
    'stepTwentyReg.webp',
    'stepTwentyoneReg.webp',
    'stepTwentyTwoReg.webp',
    'stepTwentythreeReg.webp',
    'stepTwentyfourReg.webp',
];
export const registrationImagesEng = [
    'stepOneRegEng.webp',
    'stepTwoRegEng.webp',
    'stepThreeRegEng.webp',
    'stepFourRegEng.webp',
    'stepFiveRegEng.webp',
    'stepSixRegEng.webp',
    'stepSevenRegEng.webp',
    'stepEightRegEng.webp',
    'stepNineRegEng.webp',
    'stepTenRegEng.webp',
    'stepElevenRegEng.webp',
    'stepTwelveRegEng.webp',
    'stepThirteenRegEng.webp',
    'stepFourTeenRegEng.webp',
    'stepFifteenRegEng.webp',
    'stepSixteenRegEng.webp',
    'stepSeventeenRegEng.webp',
    'stepEighteenRegEng.webp',
    'stepNineteenRegEng.webp',
    'stepTwentyRegEng.webp',
    'stepTwentyoneRegEng.webp',
    'stepTwentytwoRegEng.webp',
    'stepTwentythreeRegEng.webp',
    'stepTwentyfourRegEng.webp',
];
export const xBitnetCryptoDepositImages = [
    'cryptoDepositStepOne.webp',
    'cryptoDepositStepTwo.webp',
    'cryptoDepositStepThree.webp',
    'cryptoDepositStepFour.webp',
    'cryptoDepositStepFive.webp',
];
export const xBitnetCryptoWithdrawImages = [
    'cryptoWithdrawStepOne.webp',
    'cryptoWithdrawStepTwo.webp',
    'cryptoWithdrawStepThree.webp',
    'cryptoWithdrawStepFour.webp',
    'cryptoWithdrawStepFive.webp',
    'cryptoWithdrawStepSix.webp',
    'cryptoWithdrawStepSeven.webp',
];
export const xBitnetFiatDepositImages = [
    'fiatDepositStepOne.webp',
    'fiatDepositStepTwo.webp',
    'fiatDepositStepThree.webp',
];
export const xBitnetFiatWithdrawImages = [
    'fiatWithdrawStepOne.webp',
    'fiatWithdrawStepTwo.webp',
    'fiatWithdrawStepThree.webp',
    'fiatWithdrawStepFour.webp',
    'fiatWithdrawStepFive.webp',
    'fiatWithdrawStepSix.webp',
];
export const depositCryptoBankwireTitles = [
    {
        title: 'common_dashboard',
        number: '01',
    },
    {
        title: 'wallet_action_deposit',
        number: '02',
    },
    {
        title: 'common_crypto',
        number: '03',
    },
    {
        title: 'landing_qa_choose_crypto',
        number: '04',
    },
    {
        title: 'landing_qa_choose_network',
        number: '05',
    },
    {
        title: 'landing_qa_scan_qr',
        number: '06',
    },
];
export const depositCryptoXbitnetSteps = [
    {
        title: 'click_deposit_button',
        number: '01',
    },
    {
        title: 'select_crypto_toggle_button',
        number: '02',
    },
    {
        title: 'click_cryptocurrency',
        number: '03',
    },
    {
        title: 'click_generate_address_button',
        number: '04',
    },
    {
        title: 'scan_qr_code',
        number: '05',
    },
];
export const cryptoWithdrawXbitnetSteps = [
    {
        title: 'click_withdraw_button',
        number: '01',
    },
    {
        title: 'select_crypto_toggle_button',
        number: '02',
    },
    {
        title: 'click_cryptocurrency',
        number: '03',
    },
    {
        title: 'enter_amount',
        number: '04',
    },
    {
        title: 'enter_wallet_address',
        number: '05',
    },
    {
        title: 'click_continue_button',
        number: '06',
    },
    {
        title: 'click_continue_button',
        number: '07',
    },
];
export const fiatDepositXbitnetSteps = [
    {
        title: 'click_deposit_button',
        number: '01',
    },
    {
        title: 'click_continue_button',
        number: '02',
    },
    {
        title: 'copy_provided_information',
        number: '03',
    },
];
export const fiatWithdrawXbitnetSteps = [
    {
        title: 'click_withdraw_button',
        number: '01',
    },
    {
        title: 'click_continue_button',
        number: '02',
    },
    {
        title: 'enter_amount',
        number: '03',
    },
    {
        title: 'enter_iban_address',
        number: '04',
    },
    {
        title: 'click_continue_button',
        number: '05',
    },
    {
        title: 'click_continue_button',
        number: '06',
    },
];
export const depositFiatTitles = [
    {
        title: 'common_dashboard',
        number: '01',
    },
    {
        title: 'wallet_action_deposit',
        number: '02',
    },
    {
        title: 'common_fiat_traditional_currency',
        number: '03',
    },
    {
        title: 'currency_gel',
        number: '04',
    },
    {
        title: 'common_bank_wire',
        number: '05',
    },
    {
        title: 'common_continue',
        number: '06',
    },
    {
        title: 'landing_qa_enter_recipient_acc_number',
        number: '07',
    },
];
export const depositFiatCardTitles = [
    {
        title: 'common_dashboard',
        number: '01',
    },
    {
        title: 'wallet_action_deposit',
        number: '02',
    },
    {
        title: 'common_fiat_traditional_currency',
        number: '03',
    },
    {
        title: 'currency_gel',
        number: '04',
    },
    {
        title: 'landing_qa_debit_card',
        number: '05',
    },
    {
        title: 'common_continue',
        number: '06',
    },
    {
        title: 'landing_qa_choose_amount',
        number: '07',
    },
    {
        title: 'landing_qa_add_card',
        number: '08',
    },
    {
        title: 'landing_qa_card_details',
        number: '09',
    },
    {
        title: 'landing_qa_choose_card',
        number: '10',
    },
    {
        title: 'common_continue',
        number: '11',
    },
];
export const withdrawCryptoBankWireTitles = [
    {
        title: 'common_dashboard',
        number: '01',
    },
    {
        title: 'wallet_action_withdraw',
        number: '02',
    },
    {
        title: 'common_crypto',
        number: '03',
    },
    {
        title: 'landing_qa_choose_crypto',
        number: '04',
    },
    {
        title: 'landing_qa_choose_crypto_amount',
        number: '05',
    },
    {
        title: 'landing_qa_choose_crypto_address',
        number: '06',
    },
    {
        title: 'landing_qa_choose_network',
        number: '07',
    },
    {
        title: 'common_continue',
        number: '08',
    },
    {
        title: 'common_continue',
        number: '09',
    },
];
export const stepFiatBankwireTitles = [
    {
        title: 'common_dashboard',
        number: '01',
    },
    {
        title: 'wallet_action_withdraw',
        number: '02',
    },
    {
        title: 'common_fiat_traditional_currency',
        number: '03',
    },
    {
        title: 'currency_gel',
        number: '04',
    },
    {
        title: 'common_bank_wire',
        number: '05',
    },
    {
        title: 'common_continue',
        number: '06',
    },
    {
        title: 'landing_qa_choose_amount',
        number: '07',
    },
    {
        title: 'landing_qa_enter_account_number',
        number: '08',
    },
    {
        title: 'common_continue',
        number: '09',
    },
    {
        title: 'common_continue',
        number: '10',
    },
    {
        title: 'landing_qa_recieved_sms',
        number: '11',
    },
];
export const stepFiatCardTitles = [
    {
        title: 'common_dashboard',
        number: '01',
    },
    {
        title: 'wallet_action_withdraw',
        number: '02',
    },
    {
        title: 'common_fiat_traditional_currency',
        number: '03',
    },
    {
        title: 'currency_gel',
        number: '04',
    },
    {
        title: 'landing_qa_debit_card',
        number: '05',
    },
    {
        title: 'common_continue',
        number: '06',
    },
    {
        title: 'landing_qa_choose_amount',
        number: '07',
    },
    {
        title: 'landing_qa_choose_card',
        number: '08',
    },
    {
        title: 'common_continue',
        number: '09',
    },
    {
        title: 'common_continue',
        number: '10',
    },
    {
        title: 'landing_qa_recieved_sms',
        number: '11',
    },
];
export const RegistrationTitles = [
    {
        title: 'click_registration_button',
        number: '01',
    },
    {
        title: 'enter_email_or_phone_number',
        number: '02',
    },
    {
        title: 'enter_password',
        number: '03',
    },
    {
        title: 'click_continue_button',
        number: '04',
    },
    {
        title: 'check_your_inbox',
        number: '05',
    },
    {
        title: 'enter_one_time_password',
        number: '06',
    },
    {
        title: 'click_2fa_management_button',
        number: '07',
    },
    {
        title: 'click_google_2fa_toggle_button',
        number: '08',
    },
    {
        title: 'enter_one_time_code_from_email',
        number: '09',
    },
    {
        title: 'scan_qr_and_enter_google_2fa_code',
        number: '10',
    },
    {
        title: 'click_skip_button',
        number: '11',
    },
    {
        title: 'click_confirmation_button',
        number: '12',
    },
    {
        title: 'click_go_through_verification_button',
        number: '13',
    },
    {
        title: 'click_get_verified_button',
        number: '14',
    },
    {
        title: 'click_continue_button_1',
        number: '15',
    },
    {
        title: 'click_continue_button_2',
        number: '16',
    },
    {
        title: 'select_other_countries',
        number: '17',
    },
    {
        title: 'select_country_and_document_type',
        number: '18',
    },
    {
        title: 'scan_and_upload_id_document',
        number: '19',
    },
    {
        title: 'click_continue_button_3',
        number: '20',
    },
    {
        title: 'click_im_ready_button',
        number: '21',
    },
    {
        title: 'fill_out_kyc_questionnaire_and_click_submit_button',
        number: '22',
    },
    {
        title: 'wait_for_status_update',
        number: '23',
    },
    {
        title: 'success_page',
        number: '24',
    },
];
//# sourceMappingURL=index.js.map